// extracted by mini-css-extract-plugin
export default {"titleContainer":"Title_titleContainer__w-87W","titleLeft":"Title_titleLeft__1JgwC","titleRight":"Title_titleRight__ypjs6","title":"Title_title__MJS8x"};